import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces, hexToRgbaWithAlpha } from '../../theme';
import { FA_SELECTOR } from '../../styles/variables';
import { mask } from '../../styles/mixins';
import { drawerBase } from './drawerBase';

export const useNewShipmentDrawerStyles = createStyles(({ token }) => {
  const base = drawerBase({ width: 685, token });
  return {
    newShipmentDrawer: {
      ...base,

      '&.ant-drawer.ant-drawer-open .ant-drawer-mask': {
        ...mask(65),
        backdropFilter: 'blur(2px)',
        zIndex: 'auto',
      },

      '.ant-drawer-header': {
        padding: 0,
      },

      '.ant-drawer-header-title': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        height: 40,
        border: `1px solid ${ThemeColors.COLOR_WHITE}`,
        borderTopLeftRadius: token.borderRadiusLG,
        backgroundColor: ThemeColors.COLOR_WHITE3,
        boxShadow: `0 3px 10px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH3, 0.5)}`,
        zIndex: 3,

        '&::before': {
          content: '""',
          position: 'absolute',
          bottom: 3,
          left: 0,
          right: 0,
          height: 1,
          backgroundColor: ThemeColors.COLOR_WHITE,
        },

        '.ant-drawer-title': {
          flex: '0 1 auto',
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: token.fontSizeHeading4,
          fontWeight: 'bold',
        },
      },

      '&.ant-drawer-open .ant-drawer-content-wrapper': {
        boxShadow: `0 0 0 1px ${ThemeColors.COLOR_WHITE}, -2px 0 35px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY6, 0.5)}`,
      },

      '> .ant-drawer-content-wrapper': {
        ...base['> .ant-drawer-content-wrapper'],
        top: 20,
        bottom: 15,
        zIndex: 100,

        '.ant-drawer-body': {
          ...base['> .ant-drawer-content-wrapper']['.ant-drawer-body'],
          position: 'relative',
          padding: 0,
          overflow: 'hidden',

          [`@media (min-width: ${token.screenLGMin}px)`]: {
            padding: `${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_15}px 0`,
          },
          [`@media (max-width: ${token.screenMDMax}px)`]: {
            padding: `${ThemeSpaces.SPACE_NORM}px 0`,
          },
        },
      },
    },
    headerRightContent: {
      position: 'absolute',
      right: ThemeSpaces.SPACE_SM,
      top: '50%',
      transform: 'translateY(-50%)',

      '.ant-btn': {
        [FA_SELECTOR]: {
          '&:last-child': {
            marginLeft: 0,
          },
        },
      },

      [`@media (min-width: ${token.screenLGMin}px)`]: {
        display: 'block',
      },
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        display: 'none',
      },
    },
  };
});
